/**
 * Visibilidad de campos de mortalidad / vísceras según residuo y tipo de establecimiento.
 * Misma lógica que el modal de líneas de residuo del generador de guías.
 */
import { MORTALITY_RESIDUE_IDS } from './residuosObservacionesAuto';
import {
	CULTIVATION_CENTER_TYPE_IDS,
	PRIMARY_PLANT_TYPE_ID,
} from '../constants/guideConstants';

const EMPTY = {
	showEnsilageFields: false,
	showViscerasFields: false,
	showFishCount: false,
	showNumberOfBins: false,
	showBinSealFolios: false,
	showCultivationCenterOrigin: false,
	showCageOrigin: false,
	isPecesEnterosPlanta: false,
	isPecesEnteroCentro: false,
	isPecesEnterosIneligible: false,
};

/**
 * @param {string} residueId - `_id` del residuo seleccionado
 * @param {string} establishmentTypeId - `establishment_type_id` del establecimiento activo / origen
 */
export function getMortalityFieldVisibility(residueId, establishmentTypeId) {
	if (!residueId) return { ...EMPTY };

	const isCultivationCenter =
		CULTIVATION_CENTER_TYPE_IDS.includes(establishmentTypeId);
	const isPrimaryPlant = establishmentTypeId === PRIMARY_PLANT_TYPE_ID;

	const isEnsilada = residueId === MORTALITY_RESIDUE_IDS.ENSILADA;
	const isPecesEnteros = residueId === MORTALITY_RESIDUE_IDS.PECES_ENTEROS;
	const isVisceras = residueId === MORTALITY_RESIDUE_IDS.VISCERAS;

	const isPecesEnterosPlanta = isPecesEnteros && isPrimaryPlant;
	const isPecesEnteroCentro = isPecesEnteros && isCultivationCenter;
	const isPecesEnterosIneligible =
		isPecesEnteros && !isPecesEnterosPlanta && !isPecesEnteroCentro;

	return {
		showEnsilageFields: isEnsilada,
		showViscerasFields: isVisceras,
		showFishCount: isEnsilada || isPecesEnteros,
		showNumberOfBins: isEnsilada || isVisceras || isPecesEnteroCentro,
		showBinSealFolios: isPecesEnteroCentro,
		showCultivationCenterOrigin: isVisceras || isPecesEnterosPlanta,
		showCageOrigin: isVisceras || isPecesEnteros,
		isPecesEnterosPlanta,
		isPecesEnteroCentro,
		isPecesEnterosIneligible,
	};
}
